/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const getProfileDetailsAction = createAction('REFORAL_GET_PROFILE_DETAILS');
export const inviteDentistAction = createAction('REFORAL_INVITE_DENTIST');
export const cancelDentistInviteAction = createAction('REFORAL_CANCEL_DENTIST_INVITE');

// DENTIST PROFILE START
export const updateDentistProfileBioAction = createAction('REFORAL_UPDATE_DENTIST_PROFILE_BIO');
export const updateDentistProfileServicesAction = createAction('REFORAL_UPDATE_DENTIST_PROFILE_SERVICES');
export const updateDentistProfileAction = createAction('REFORAL_UPDATE_DENTIST_PROFILE');
export const updateDentistEducationAction = createAction('REFORAL_UPDATE_DENTIST_EDUCATION');
export const deleteDentistEducationAction = createAction('REFORAL_DELETE_DENTIST_EDUCATION');
// DENTIST PROFILE END

// CLINIC PROFILE START
export const updateClinicProfileBioAction = createAction('REFORAL_UPDATE_CLINIC_PROFILE_BIO');
export const updateClinicContactDetailsAction = createAction('REFORAL_UPDATE_CLINIC_CONTACT_DETAILS');
export const updateClinicProfileServicesAction = createAction('REFORAL_UPDATE_CLINIC_PROFILE_SERVICES');
export const updateClinicProfileInformationAction = createAction('REFORAL_UPDATE_CLINIC_PROFILE_INFORMATION');
export const updateClinicProfileAction = createAction('REFORAL_UPDATE_CLINIC_PROFILE');
export const deleteClinicHoursAction = createAction('REFORAL_DELETE_CLINIC_HOURS');
// ENH-052: the clinic's guest referral link
export const getGuestReferralLinkAction = createAction('REFORAL_GET_GUEST_REFERRAL_LINK');
export const activateGuestReferralLinkAction = createAction('REFORAL_ACTIVATE_GUEST_REFERRAL_LINK');
export const deactivateGuestReferralLinkAction = createAction('REFORAL_DEACTIVATE_GUEST_REFERRAL_LINK');
// CLINIC PROFILE END

// LAB PROFILE START
export const updateLabProfileBioAction = createAction('REFORAL_UPDATE_LAB_PROFILE_BIO');
export const updateLabProfileServicesAction = createAction('REFORAL_UPDATE_LAB_PROFILE_SERVICES');
export const updateLabProfileInformationAction = createAction('REFORAL_UPDATE_LAB_PROFILE_INFORMATION');
export const updateLabProfileAction = createAction('REFORAL_UPDATE_LAB_PROFILE');
export const deleteLabHoursAction = createAction('REFORAL_DELETE_LAB_HOURS');
// LAB PROFILE END

export const sendProfileVerificationCodeAction = createAction('REFORAL_SEND_PROFILE_VERIFICATION_CODE');
export const verifyProfileCodeAction = createAction('REFORAL_VERIFY_PROFILE_CODE');

export const setVerificationDetailsAction = createAction('REFORAL_SET_VERIFICATION_DETAILS');
